import { Accounting } from 'anchor-scout-common/types';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { AccountingItemType } from '~/types/api/accounting-integration';
const DEFAULT_TYPES = [
    AccountingItemType.Service,
    AccountingItemType.Bundle
];
const queryKeyFor = (accounting)=>accounting === Accounting.QBO ? QueryKeys.QboItems : QueryKeys.XeroItems;
export function useAccountingItems(accounting) {
    let { refreshOnHookMount = false, enabled = true } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            queryKeyFor(accounting)
        ],
        queryFn: ()=>api.accounting.getItems({
                accounting,
                type: DEFAULT_TYPES
            }),
        enabled,
        refreshOnHookMount
    });
    return {
        items: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
}
